import React, { useState } from 'react';
import { Box, Skeleton } from '@mui/material';
import HoldingCardSkeleton from './HoldingCardSkeleton';
import PortfolioTableViewSkeleton from './PortfolioTableViewSkeleton';

interface PortfolioHoldingsSkeletonProps {
  holdingCount?: number;
}

const PortfolioHoldingsSkeleton: React.FC<PortfolioHoldingsSkeletonProps> = ({ 
  holdingCount = 6 
}) => {
  const [viewMode, setViewMode] = useState<'table' | 'cards'>('table');

  return (
    <Box>
      {/* Header */}
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={3}>
        <Skeleton 
          variant="text" 
          width={200} 
          height={32}
          sx={{
            fontWeight: 600,
            color: (theme) =>
              theme.palette.mode === 'dark' ? '#ffffff' : '#1d1d1f',
          }}
        />
        
        {/* ViewModeToggle Skeleton */}
        <Box
          sx={{
            display: 'inline-flex',
            background: (theme) =>
              theme.palette.mode === 'dark'
                ? 'rgba(255, 255, 255, 0.05)'
                : 'rgba(0, 0, 0, 0.04)',
            // REMOVED for performance: backdropFilter: 'blur(20px)',
            borderRadius: 3,
            padding: 0.25,
            border: (theme) =>
              theme.palette.mode === 'dark'
                ? '1px solid rgba(255, 255, 255, 0.1)'
                : '1px solid rgba(0, 0, 0, 0.08)',
            boxShadow: (theme) =>
              theme.palette.mode === 'dark'
                ? '0 2px 10px rgba(0, 0, 0, 0.3)'
                : '0 2px 10px rgba(0, 0, 0, 0.08)',
          }}
        >
          <Skeleton variant="rounded" width={170} height={32} />
        </Box>
      </Box>

      {/* Holdings Content */}
      {viewMode === 'table' ? (
        <PortfolioTableViewSkeleton rowCount={holdingCount} />
      ) : (
        /* Card View */
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: '1fr',
              md: 'repeat(2, 1fr)',
              lg: 'repeat(3, 1fr)',
              xl: 'repeat(3, 1fr)',
            },
            gap: 3,
          }}
        >
          {Array.from({ length: holdingCount }, (_, index) => (
            <HoldingCardSkeleton key={index} />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default PortfolioHoldingsSkeleton;